const previewSuffix =
  /:\s*(?:safely rasterized still preview|converted still preview|static first-frame poster|browser-decoded still preview)[^]*$/i;

/** Keep conversion details in file metadata instead of using them as a title. */
export function displayObjectName(value: unknown, fallback = "Image") {
  const name = String(value || "")
    .replace(previewSuffix, "")
    .trim();
  return name || fallback;
}
